import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';
import ECommSession, { ECommStripePaymentProvider } from "../ecomm";
import ECommForm from "../ecommForm";

export default class ArbitraryAmountFormJs {
    constructor() {
        this.running = false;
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }

    async init(container$, product) {
        this.container$ = container$;
        this.product = product;

        const pp = new ECommStripePaymentProvider({
            paymentProviderReferenceName: ECommSettings.StripePaymentProvider
        });

        this.session = new ECommSession();
        await this.session.initAsync({
            paymentProvider: pp
        });

        this.ecommFields = new ECommForm(container$);
    }


    async paymentSubmit() {
        const amt = parseFloat(this.container$.find("[name='amount']").val());
        const priceOverride = parseInt(amt * 100);
        const info = this.ecommFields.getCustomerInfo();

        const session = this.session;
        await session.getCustomer().updateInfo({
            info: info.Info
        });

        let customer = session.getCustomer();
        let order = await customer.newOrderAsync();

        await order.addCustomPriceItemAsync({
            variantID: this.product.VariantID,
            measureID: this.product.MeasureID,
            description: this.product.Title,
            quantity: 1,
            priceOverride
        });

        await order.checkoutAsync({
            shippingAddress: info.ShippingAddress,
            billingAddress: info.BillingAddress,
            payment: info.Payment,
            amt,
            orderID: order.order.OrderID
        });
    }

    async postArbitraryAmountForm(e, tokenId, successMessageId, failedMessageId, loadingId, inputSectionId, iconId, successIconUrl) {
        e.preventDefault();

        if (this.submitting) return;
        this.submitting = true;

        var that = this;

        let button = that.utilsjs.disableButton(e);
        that.utilsjs.hideById(failedMessageId);
        that.utilsjs.hideById("failedArbitraryMessage");
        that.utilsjs.showById(loadingId);
        document.getElementById(tokenId).value = await grecaptcha.execute(SiteSettings.GoogleRecaptchaKey, { action: 'arbitraryAmountFormPage' });

        //Transaction:
        try {
            this.ecommFields.hideError();
            await this.paymentSubmit();

            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(successMessageId);
            that.utilsjs.hideById(failedMessageId);
            that.utilsjs.hideById("failedArbitraryMessage");
            that.utilsjs.hideById("customFailedDuesMessage");
            that.utilsjs.hideById(inputSectionId);
            document.getElementById(iconId).src = successIconUrl;
        } catch (ex) {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(failedMessageId);
            that.utilsjs.showById("customFailedDuesMessage");
            that.utilsjs.hideById(successMessageId);
        }

        //UGC:
        //if (await that.ajaxjs.serializeAndPostForm(e.target.id, 'JobPostingFormPost', 'Module') === '201') {
        //    that.utilsjs.hideById(loadingId);
        //    that.utilsjs.showInlineById(successMessageId);
        //    that.utilsjs.hideById(failedMessageId);
        //    that.utilsjs.hideById(inputSectionId);
        //    document.getElementById(iconId).src = successIconUrl;
        //} else {
        //    that.utilsjs.hideById(loadingId);
        //    that.utilsjs.showById(failedMessageId);
        //    that.utilsjs.hideById(successMessageId);
        //}
        button.disabled = false;
        this.submitting = false;
    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/arbitraryAmountForm.js